module.exports = __webpack_public_path__ + "media/images/cards/cc-amazon-pay-292957141876735e39d926d311facd43.svg";